import { createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import { auth, firestore as db } from "../config/Config";


const  initialState={
   quotationNames:[],
  quotationModal:false,
  quotationError:{}
}

export const createQuotations = createAsyncThunk('createQuotationList',
  async ({ clientId, quotationData }, { rejectWithValue }) => {
    try {
      const response = await fetch(`https://us-central1-fabdiz-quote.cloudfunctions.net/api/project/${clientId}/quotations`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(quotationData),
      });

      if (!response.ok) {
        throw new Error('Server Error');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
const addQuotationReducer = createSlice({
    name:'createQuotation',
    initialState: {
    quote: [],
    loading: false,
    error: null,
  },
    reducers:{},
    extraReducers: (builder) => {
      builder
        .addCase(createQuotations.pending, (state) => {
          state.loading = true;
        })
        .addCase(createQuotations.fulfilled, (state, action) => {
          // state.rooms.push(action.payload);
          state.loading = false;
        })
        .addCase(createQuotations.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        });
    },
});

export default addQuotationReducer.reducer